import BackgroungColorComponent from '../../customComponents/BackgroungColorComponent';
import WithAccordion from '../../customComponents/CustomAccordion';
import ColorPicker from '../../../puck/reusable-props/ColorPicker';

export interface ISelectedOptionCustomizationProps {
  background: {
    color: string;
    isInherit: boolean;
  };
  borderColor: string;
}

interface IProps {
  value: ISelectedOptionCustomizationProps;
  onChange: (_value: ISelectedOptionCustomizationProps) => void;
  title?: string;
}

const SelectedOptionCustomization = ({
  value,
  onChange,
  title = 'Customize Selected Option',
}: IProps) => {
  return (
    <WithAccordion title={title}>
      <BackgroungColorComponent
        value={value?.background}
        onChange={background => {
          onChange({ ...value, background });
        }}
      />
      <ColorPicker
        label="Border Color"
        tooltip="borderColor"
        value={value?.borderColor}
        onChange={color => {
          onChange({
            ...value,
            borderColor: color,
          });
        }}
      />
    </WithAccordion>
  );
};

export default SelectedOptionCustomization;
